<template>
  <page-edicion>
    <page-header :title="descuento.descripcion" subtitle="Descuento" back-to="/descuentos" />
    <formulario :descuento="descuento" @submit="actualizar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import * as tipoDescuentoApi from "@/services/tipoDescuento.js";

export default {
  components: { Formulario },
  data() {
    return {
      descuento: {},
    };
  },
  mounted() {
    this.cargar(this.$route.params.id);
  },
  methods: {
    cargar(id) {
      tipoDescuentoApi.cargar(id).then((response) => {
        this.descuento = response;
      });
    },
    actualizar() {
      var descuento = {
        descuento: this.descuento,
      };
      tipoDescuentoApi.actualizar(descuento).then(() => {
        this.$router.push({ path: "/descuentos" });
      });
    },
  },
};
</script>
